import React, { useEffect } from 'react';
import { DragSource as dragSource } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import classnames from 'classnames';
import { func, string, bool, shape, arrayOf } from 'prop-types';
import AC_GRID from '../../AutocodeTypes';
import AutocodeCheckBox from '../../ACShared/AutocodeCheckBox';

const source = {
  beginDrag(props) {
    const selectedNodes = [];
    switch (props.ACTemplateType) {
      case AC_GRID.AC_TEMPLATE_1_CATEGORY:
        selectedNodes.push(...props.selectedItems.filter(i => i.checked));
        return {
          selectedNodes,
          selectedNodeAnswers: props.selectedNodeAnswers,
          ACTemplateType: props.ACTemplateType,
          userOptions: props.userOptions,
          selectedUserOption: props.selectedUserOption,
          totalUsersItem: props.totalUsersItem,
        };
      case AC_GRID.AC_TEMPLATE_1_BRAND_TYPE_KIND_FORM:
        selectedNodes.push(...props.selectedItems.filter(i => i.checked));
        return {
          selectedNodes,
          selectedNodeAnswers: props.selectedNodeAnswers,
          ACTemplateType: props.ACTemplateType,
          userOptions: props.userOptions,
          selectedUserOption: props.selectedUserOption,
          onePlusSelected: props.onePlusSelected,
          onePlusValue: props.onePlusValue,
        };
      case AC_GRID.AC_TEMPLATE_4:
        selectedNodes.push(...props.selectedItems.filter(i => i.checked));
        return {
          selectedNodes,
          selectedNodeAnswers: props.selectedNodeAnswers,
          ACTemplateType: props.ACTemplateType,
          userOptions: props.userOptions,
          selectedUserOption: props.selectedUserOption,
        };
      case AC_GRID.AC_TEMPLATE_2:
      case AC_GRID.AC_TEMPLATE_7:
      case AC_GRID.AC_TEMPLATE_8:
        return {
          selectedList1: props.selectedList1,
          selectedList2: props.selectedList2,
          selectedNodeAnswers: props.selectedNodeAnswers,
          ACTemplateType: props.ACTemplateType,
          or: props.or,
        };
      default:
        selectedNodes.push(...props.selectedItems.filter(i => i.checked));
        return {
          selectedNodes,
          selectedNodeAnswers: props.selectedNodeAnswers,
          ACTemplateType: props.ACTemplateType,
        };
    }
  },
  endDrag(props, monitor) {
    if (monitor.didDrop()) {
      props.resetSelectedRows();
    }
  },
};

const collect = (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging(),
});
const ACTemplateRow = props => {
  const {
    onChange,
    id,
    isChecked,
    fill,
    stroke,
    data,
    label,
    connectDragSource,
    connectDragPreview,
    isDragable,
  } = props;
  useEffect(() => {
    connectDragPreview(getEmptyImage(), {
      captureDraggingState: true,
    });
  }, []);

  const rederACTemplateRow = () => {
    return (
      <div
        key={id}
        className={classnames('ac-dictionary-row', {
          'ac-dictionary-checked': isChecked,
        })}
      >
        <div className="ac-dictionary-row-checkbox">
          <AutocodeCheckBox
            onChange={onChange}
            id={id}
            isChecked={isChecked}
            fill={fill}
            stroke={stroke}
            data={data}
            label={label}
          />
        </div>
      </div>
    );
  };

  return isDragable
    ? connectDragSource(rederACTemplateRow())
    : rederACTemplateRow();
};

ACTemplateRow.propTypes = {
  onChange: func,
  id: string,
  isChecked: bool,
  fill: string,
  stroke: string,
  label: string,
  data: shape({}),
  selectedItems: arrayOf(shape({})),
  selectAll: func,
  resetSelectedRows: func,
  ACTemplateType: string,
  userOptions: arrayOf(shape({})),
  selectedUserOption: string,
  totalUsersItem: shape({}),
  isDragable: bool,
  selectedList1: arrayOf(shape({})),
  selectedList2: arrayOf(shape({})),
};

export default dragSource(AC_GRID.AC_GRID_1, source, collect)(ACTemplateRow);
